import { separateArrayElements } from './array'

export const splitAndKeepSeparator = (str: string, separator: string) => {
  const nonSeparatorParts = str.split(separator)
  return separateArrayElements(separator, nonSeparatorParts)
}

export const toLowerCase = (x: string) => x.toLowerCase()

export const includeString = (arr: string[]) => (str: string) => arr.includes(str)
